import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './WelcomeScreen.css';

function WelcomeScreen() {
  const navigate = useNavigate();
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(0);
    setTouchStart(e.targetTouches[0].clientY);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientY);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    if (distance > minSwipeDistance) {
      navigate('/consent');
    }
  };

  return (
    <div
      className="welcome-screen"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onClick={() => navigate('/consent')}
    >
      <div className="welcome-logo-section">
        <img
          src="/images/eye2voice_logo_img.png"
          alt="Eye2Voice icon"
          className="welcome-logo-icon"
        />
        <img
          src="/images/eye2voice_logo_text.png"
          alt="Eye2Voice"
          className="welcome-logo-text"
        />
      </div>

      <div className="welcome-tagline">
        <p>LOOK.</p>
        <p>DECIDE.</p>
        <p>SPEAK</p>
      </div>

      <div className="welcome-swipe">
        <p className="welcome-swipe-label">SWIPE UP TO BEGIN</p>
        <div className="welcome-swipe-circle">
          <span className="welcome-swipe-arrow">↑</span>
        </div>
      </div>
    </div>
  );
}

export default WelcomeScreen;